import React, { PureComponent } from 'react';
import { IMAGES_REPO } from '../../config';

class Article extends PureComponent {
  render() {
    const { id, body, image, link, title } = this.props;
    return (
      <div className="article">
        <a target="_blank" href={link}>
          <img
            className="image pull-left"
            src={`${IMAGES_REPO}${image}`}
            alt={`Article ${id}`}/></a>
        <div className="article__info">
          <h3>{title}</h3>
          <a
            className="article__text"
            target="_blank"
            href={link} dangerouslySetInnerHTML={{ __html: body }}></a>
        </div>
      </div>
    );
  }
}

Article.propTypes = {};
Article.defaultProps = {};

export default Article;



// WEBPACK FOOTER //
// ./src/components/article/Article.js